<template>
	<div class="login">
		<div class="logo">
			<img src="/img/livelines_logo.png" />
		</div>
		<div class="center">
			<p>Login To Your <b>Livelines</b> Account</p>
		</div>
		<div class="alert alert-danger text-center" role="alert" v-if="this.error">
			{{ this.error }}
		</div>
		<div class="form-group">
			<input v-model="email" name="email" type="text" class="form-control" placeholder="Email Address" required autofocus v-on:keyup.enter="login" :class="{ 'error' : this.errors.email }" @blur="this.validate">
			<button class="btn prepend" disabled><eva-icon name="email" animation="pulse" fill="gray"></eva-icon></button>
			<p class="error-reason">{{ this.errors.email }}</p>
		</div>
		<div class="form-group">
			<input v-model="password" name="password" type="password" class="form-control" placeholder="Password" required v-on:keyup.enter="login" :class="{ 'error' : this.errors.password }" @blur="this.validate">
			<button class="btn prepend" disabled><eva-icon name="lock" animation="pulse" fill="gray"></eva-icon></button>
			<p class="error-reason">{{ this.errors.password }}</p>
		</div>
		<div class="center"><router-link to="/forgot-password">Forgot Your Password?</router-link></div>
		<button type="submit" class="btn primary" @click="login">Login</button>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	
	name: "LoginPage",

	data() {

		return {
			service: 'e6a3c44c-7b9b-4bcd-9d86-26d99758d409',
			email: null,
			password: null,
			submitted: 0,
			error: null,
			errors: []
		}

	},

	mounted() {
		this.storeCallback();
		this.isAuthorised();
	},

	methods: {

		storeCallback: function(event) {
			if(this.$route.query.callback) {
                localStorage.setItem('callback', this.$route.query.callback);
                let query = Object.assign({}, this.$route.query);
                delete query.callback;
				this.$router.replace({ query });
			}
		},

		isAuthorised: function(event) {
			if (localStorage.getItem("user-token") !== null) {
				
				var token = localStorage.getItem('user-token')
				
				axios
					.get('authentication/refresh', {
						headers: {
							Authorization: 'Bearer ' + localStorage.getItem('user-token')
						}
					} )
					.then(response => {
						localStorage.setItem('user-token', response.data.token)
						window.location.href = localStorage.getItem('callback') + '?token=' + response.data.token
					})
			}

		},

		validate: function(event) {

			if(this.submitted == 1) {

				this.errors = []

				if(this.email === null) {
					this.errors.email = 'Please enter your Email Address'
				} else if(this.email.length < 6) {
					this.errors.email = 'Please enter a valid Email Address'
				}

				if(this.password === null) {
					this.errors.password = 'Please enter a Password'
				} else if(this.password.length < 6) {
					this.errors.password = 'Password must be at least 6 characters'
				}

			}

		},


		login: function(event) {

			this.submitted = 1;

			this.validate()

			if(Object.keys(this.errors).length == 0) {
			
				axios
					.post('authentication/login', {
						service: this.service,
						email: this.email,
						password: this.password
					})
					.then(response => {
						localStorage.setItem('user-token', response.data.token)
						window.location.href = localStorage.getItem('callback') + '?token=' + response.data.token
					})
					.catch(error => {
						if(error.response.data.error == "Invalid Credentials") {
							this.error = "Login Failed. Please Try Again."
						}
					})

			}
		},

	}
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.center {
	text-align: center
}

p {
	margin: 15px 0 30px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.7;
    color: #bdbac2;
}

.form-group {
    margin-bottom: -5px;
}

.form-control {
    background: #f5f5f5;
    color: #bdbac2;
    border: none;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
}

.primary {
    display: inline-block;
    padding: 14px 0;
    width: 100%;
    background: #007bff;
    font-weight: 600;
    line-height: 1.7;
    color: #fff;
    text-align: center;
    border-radius: 6px;
	margin-top: 15px;
	margin-bottom: 25px;
}

.prepend {
	margin-top: -84px;
}

a {
    color: #007bff;
}

.logo {
	text-align: center;
}

.logo img {
	width: 300px;
	margin-bottom: 15px;
}

.error {
	border: 1px solid red;
}

.error-reason {
	margin: -20px 0px 15px 0px;
	font-size: 12px;
	text-align: right;
}

</style>
